export const environment = {
  production: false,
  CAMPAIGN_NAME: undefined,
  IS_CAMPAIGN_ENABLED: true,
  CAMPAIGN_URL: '',
  NO_RANDOM_VIDEOS: false,
  CAMPAIGN_TYPE: 'campaign',
  VIMEO_TOKEN: "bearer 8019e7bc03d8c64e18457f3f5e3eeaf1", // Sonali New
  S3_URL_PRFIX: 'https://d2k5ewco15hv0e.cloudfront.net',
  DOMAIN: 'https://d2asw23jcw8al0.cloudfront.net/',

  //MAP_API
  GMAP_API_KEY: 'AIzaSyASjCEbYI1dJ3TqW_7BmBVY6KzDPs5xU6w',
  // Gdrive API
  GDRIVE_API_KEY: 'AIzaSyASjCEbYI1dJ3TqW_7BmBVY6KzDPs5xU6w',
  // Gdrive API Prod
  // GDRIVE_API_KEY: 'AIzaSyBs8LNvbR1_coBV4SyQVtb5AU3mEbHihUk',
  //MAP_ID
  GOOGLE_MAP_ID: '23ff35f7f7f699db',

  // mixpanel key
  MIXPANEL_KEY: '43f6264f1b71797624fd01a56e981ed4',//sreeram 
  // MIXPANEL_KEY: '9d43de0e8227e48e7087f606cfba32d2',// sonali

  // API_URL:"http://127.0.0.1:3000/",
  VIDEO_BUCKET: 'windowswap-videos-dev',
  API_URL: 'https://4oqy5xbzea.execute-api.us-east-1.amazonaws.com/dev/',
  IDENTITY_POOL_ID: 'us-east-1:0a1f6a11-425b-4ed6-96da-14b0b163aac2',
  REGION: 'us-east-1',
  USERPOLL_ID: 'us-east-1_3ZFlFy1UG',
  USERPOLL_WEBCLIENT: '7ua4dgmsd4nlds58h5t3btnluo',
  DEPLOY_BUCKET: 'dev-windowswap',
  STRIPE_PUBLIC: 'pk_test_51QVX7ZJnKzs4aOGkQUVA60at46TJbqlw07CAUqi9dLVZCfBwWWVi0arSIeRcE4UnHStUUqQBbLVi4SpVTwY2Stbl00LK0TxxJj',
  // STRIPE_PUBLIC:
  //   'pk_test_51JNxBRIqWOrbEOSA50h46J9pYaYDWad0ubABAYomfsZgPsMTq1qeQKlg3CgxNNSZJuDGF6gReIyeeGWTEJo72O7h000iIG6tqR',
  //STRIPE_PUBLIC: "pk_test_51JVswAF0xop75M2tx0MxjVnaSFHL39ZjElLFSO3PbyzTR1fq9JUTpw9YsFbKO0BHZGVS0AqaIlyfoAxbY0mkOgQg00QUNMQzqM",
  AWS_EXPORT_CONFIG: {
    aws_project_region: 'us-east-1',
    aws_cognito_identity_pool_id:
      'us-east-1:0a1f6a11-425b-4ed6-96da-14b0b163aac2',
    aws_cognito_region: 'us-east-1',
    aws_user_pools_id: 'us-east-1_3ZFlFy1UG',
    aws_user_pools_web_client_id: '7ua4dgmsd4nlds58h5t3btnluo',
    oauth: {
      domain: 'da.window-swap.com',
      scope: [
        'phone',
        'email',
        'openid',
        'profile',
        'aws.cognito.signin.user.admin',
      ],
      redirectSignIn:
        'http://localhost:4200/,https://D2asw23jcw8al0.cloudfront.net/',
      redirectSignOut:
        'http://localhost:4200/,https://D2asw23jcw8al0.cloudfront.net/',
      responseType: 'code',
    },
    federationTarget: 'COGNITO_USER_POOLS',
  },
  WINDOWSWAP_APP: {
    APPLICATION_ID: 'com.windowswap.gaze.dev',
    DEEP_LINK_URL: 'dev-windowswap-gaze',
    PLAYSTORE_URL_PREFIX: 'https://play.google.com/store/apps/details?id=',
    APPLE_STORE_URL_PREFIX: 'https://apps.apple.com/us/app/snapchat/id447188370'
  }
};
